"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSPS_OPTIONS = exports.PSPS_LEVELS = void 0;
exports.PSPS_LEVELS = {
    normal: { long: 'Normal', short: 'NO' },
    watch: { long: 'Watch', short: 'WT' },
    warning: { long: 'Warning', short: 'WR' },
};
exports.PSPS_OPTIONS = [exports.PSPS_LEVELS.normal.long, exports.PSPS_LEVELS.watch.long, exports.PSPS_LEVELS.warning.long];
